var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRupee(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.14463 1H10.5909L9.94628 2.18182H7.84479C8.15421 2.52455 8.38628 2.92636 8.52165 3.36364H10.5909L9.94628 4.54545H8.65702C8.57692 5.2821 8.22775 5.97235 7.66613 6.50433C7.10452 7.0363 6.36336 7.37882 5.56281 7.47636V7.5H5.11157L8.97934 11.6364H7.36777L3.5 7.5V6.31818H5.11157C6.24612 6.31818 7.18727 5.55 7.34198 4.54545H3.5L4.14463 3.36364H7.1486C6.7876 2.66636 6.01405 2.18182 5.11157 2.18182H3.5L4.14463 1Z",
    fill: "#E95A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupee);
export default __webpack_public_path__ + "static/media/rupee.bb13e7e323f9376d7ce6b607023d97ff.svg";
export { ForwardRef as ReactComponent };